module.exports = __webpack_public_path__ + "6d417f798ce05f468f202bde7d44329a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/glyphs/q.png
// module id = 220
// module chunks = 0